import React, {useEffect, useRef, useState} from 'react';
import PopupSelectAdapter from "../PopupSelectAdapter";
import PropTypes from "prop-types";

import 'core-js/stable';
import 'regenerator-runtime/runtime';
import 'react-app-polyfill/ie11';
import PopupOptions from "../popup_select_component/PopupOptions";
import LinkForPopup from './link_implement/JobSearchOrdersTypesPopupLinkForArticles';
import {fetchPopupData} from "../popup_select_component/fetchPopupData";
import PopupSelect from "../PopupSelect";
import ReactDOM from "react-dom";

const JobSearchOrdersTypesForWorkArticles = props => {
  const [jobSearchOrderIds, setJobSearchOrderIds] = useState(props.job_search_order_ids || "");

  const url = (() => {
    const path = '/popup/job_search_orders_types';
    const data = {
      selected_ids: jobSearchOrderIds.split(","),
      is_limited_item: 0
    };
    return path + '?' + (new URLSearchParams(data)).toString();
  })();

  const onClosePopup = selectedJobSearchOrderTypes => {
    setJobSearchOrderIds(selectedJobSearchOrderTypes.map(job_search_order => job_search_order.id).join(','));
  };

  const onChangeJobSearchOrderIds = event => {
    setJobSearchOrderIds(event.target.value);
  };

  useEffect(() => {
    const handleCategoryChange = () => {
      const selectedRadio = document.querySelector('input[class="radio-input category"]:checked');
      if (selectedRadio && selectedRadio.value === '1') { // 選択されたラジオボタン「求人・発注記事を掲載（職人・協力会社等を募集する）」の場合のみ処理を実行
        setJobSearchOrderIds("");
      }
    };

    document.addEventListener('change', handleCategoryChange);

    return () => document.removeEventListener('change', handleCategoryChange);
  }, []);

  return (
    <>
      <PopupSelectAdapter
        popupOptions={PopupOptions.recruitmentPrTypes}
        fetchedData={fetchPopupData(url)}
        needSelectedAllButton={false}
        rootNode={document.querySelector('#popup_member_job_search_orders')}
        onClosePopup={onClosePopup}
        selectedNames={props.input_job_search_order_name}
        LinkForPopup={LinkForPopup}
        ButtonArea={ButtonArea}
        recruitmentPrTypes={true}
      />
      <input type="hidden"
             name="work_article[work_article_job_search_orders_ids]"
             onChange={onChangeJobSearchOrderIds}
             value={jobSearchOrderIds}
      />
    </>
  );
};

JobSearchOrdersTypesForWorkArticles.propTypes = {
  job_search_order_ids: PropTypes.string,  // ie. "1,2,3"
  input_job_search_order_name: PropTypes.string  // ie. "name1/name2/name3"
};

const ButtonArea = props => {
  return <a className="select select-job_search_order-btn" onClick={props.onClickCloseButton}>選択</a>
};

export default JobSearchOrdersTypesForWorkArticles;
